module.exports = __webpack_public_path__ + "static/media/shadow_strike.b58350ed.png";